{
	"mainUL": {
		"title": "Štartna lista ultralight",
		"nazaj": "Nazaj"
	},
	"nav": {
		"vnos": "Vnos",
		"zapisi": "Zapisi"
	},
	"labelsUL": {
		"datum": "Datum :",
		"pilot": "Izberi pilota :",
		"instruktor": "Izberi inštruktorja :",
		"reg": "Izberi reg. letala :",
		"namen": "Izberi namen :",
		"naloga": "Izberi nalogo :",
		"vzlet": "Izberi vzlet :",
		"nezakljucen": "Nezaključen let?",
		"pristanek": "Izberi pristanek :",
		"stPristankov": "Št. pristankov :",
		"opomba": "Opomba",
		"niMozno": "Ker gre za vlečni let, lahko zapis urejate samo pri jadralnih letih.",
		"stanjeStevca": "Stanje števca",
		"v_zraku": "Čas v zraku: ",
		"vnosTrajanja": "Vnos časa v zraku?",
		"novIcao": "vnesi ICAO letališča",
		"dodajLetalisce": "Dodajanje letališča"
	},
	"buttons": {
		"vnesiZapis": "Vnesi zapis",
		"brisiIzbiro": "Pobriši izbiro",
		"dodajLetalisce": "Dodaj"
	},
	"obvestila": {
		"zapisPrihodnost": "Zapis ima izbran datum v prihodnosti, POPRAVI izbran datum!",
		"zapisCasPrihodnost": "Zapis ima pri enem ali več zapisih uro v prihodnosti, preglej čase!",
		"zapisCasNapaka": "Časi zapisov so nepravilni! Preveri čase še enkrat!",
		"napakaPristanka": "Čas pristanka ne more biti pred časom poleta!",
		"zapisPobrisan": "Zapis uspešno pobrisan",
		"zapisDodan": "Zapis uspešno dodan.",
		"napakaPrazenPristanek": "Napaka pri vnosu, čas pristanka ne more biti prazen",
		"posodobitevUspesna": "Posodobitev uspešna",
		"napakaPosodabljanja": "Napaka pri posodabljanju podatkov.",
		"napakaBranja": "Napaka pri branju podatkov.",
		"napakaIzbrisa": "Napaka pri izbrisu podatkov.",
		"vprasanjeIzbris": "Ali res želite pobrisati zapis?",
		"napakaVnosa": "Napaka pri vnosu, preglej če imaš izpolnjena vsa polja!",
		"letZakljucen": "Let uspešno zaključen.",
		"letNiZakljucen": "Napaka pri zaključevanju leta.",
		"napakaDodajanjaLetalisca": "Prišlo je do napake pri vnosu letališča",
		"letalisceNiNajdeno": "ICAO koda letališča ni najdena v bazi podatkov"
	}
}